;(function (Wishlist, $) {

  var $wishlistButton = $('.wishlist-btn');
  var $addcartButton = $('.is-add-cart');
  var $wishlistTile = $('.wishlist-container');
  var wishlist = localStorage.getItem('user_wishlist') || [];
  var numProductTiles = wishlist.length;
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }

  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var productId = $(self).attr('data-product-id');
    var isRemove = $(self).hasClass('is-active');
    var isaddCart = $(self).hasClass('is-add-cart');
    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      toastr.info('Product removed from wishlist.');
      $(self).closest('tbody').animate({'line-height':0},1500).hide(1);
    } else if(isaddCart) {
      //if(cart.add(productId)) {
      cart.add(productId);
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      $(self).closest('tbody').animate({'line-height':0},1500).hide(1);
      // }
    } else {
      /* Add */ 
      wishlist.push(productHandle);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      toastr.success('Product added to wishlist.');
    }
          $('#wishlist-total span.count').html(wishlist.length);
    //console.log(JSON.stringify(wishlist));
  };

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
      }
    });
    $('#wishlist-total span.count').html(wishlist.length);
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
  var displayOnlyWishlistItems = function () {
    var items = [];
    $.each( wishlist , function( key, handle ) {
      
      var url = "/products/" + handle + ".js";
      $.getJSON(url, function(data){
      //console.log(data); 
        
       var price = data.price;

       $('table.wishlist-product').append( '<tbody class="wishlist-container" data-line="'+key+'" data-product-handle="'+ data.handle +'"><tr><td class="text-center btn-remove-product"><a type="button" data-toggle="tooltip" title="Remove" class="btn btn-danger wishlist-btn is-active" data-product-handle="'+ data.handle +'" data-line="'+ key +'"><i class="fa fa-times-circle"></i></a></td><td class="text-center"><a href="'+ data.url +'"><img src="'+ data.featured_image +'" alt="'+ data.title +'" class="cart-image img-thumbnail" /></a></td><td class="text-center"><h5><a href="'+ data.url +'">'+ data.title +'</a></h5></td><td class="text-center price-box box-special"><div class="price-box"><p class="regular-price"><span class="price" id="productPrice"><span class="money">'+ Shopify.formatMoney(price) +'</span></span></p></div></td><td class="text-center"><a href="javascript: void(0)" class="is-add-cart btn btn-primary " data-product-id="'+ data.variants[0].id +'" data-product-handle="'+ data.handle +'">Add To Cart</a></td></tr></tbody>' );
                    
      });
      
    });

    //$('table.wishlist-product').append(items.join( "" ));

      //console.log(items.join( "" ));
    /*$wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });*/
    
  };

  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      $('.wishlist-loader').fadeOut(2000, function () {
        $('.wishlist-product').show();
        //$('.wishlist-head').addClass('is_visible');
        if (numProductTiles == 0) {
          $('.wishlist-empty').show();
          $('.wishlist-head').hide();
        } else {
          $('.wishlist-empty').hide();
        }
      });
    }
  };

  var bindUIActions = function () {
    
      //$('body').on('click', '.quickview', function (){

    $(document.body).on('click', '.wishlist-btn' , function (e){
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
    $(document.body).on('click', '.is-add-cart', function (e){
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
  };

  Wishlist.init = function () {
    loadWishlist();
    bindUIActions();
    activateItemsInWishlist();
  };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));